<template>
  <div class="user">
    <div class="photo text-center pt-1">
      <strong class="text-warning" style="font-weight:600">{{'ADMINISTRADOR' | firstletter}}</strong>
    </div>
    <div class="info">
      <a data-toggle="collapse" :aria-expanded="!isClosed" @click.stop="toggleMenu" href="#">
           <span>
             ADMINISTRADOR
             <b class="caret"></b>
          </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <el-collapse-transition>
          <ul class="nav" v-show="!isClosed">
            <slot>
              <li>
                <a class="profile-dropdown" href="#/logout">
                  <span class="sidebar-mini">CS</span>
                  <span class="sidebar-normal">Cerrar Sesion</span>
                </a>
              </li>
            </slot>
          </ul>
        </el-collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
    import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
    import {EventBus} from '@/EventBus.js'

    export default {
        components: {
            [CollapseTransition.name]: CollapseTransition
        },
        props: {
            title: {
                type: String,
                default: 'Tania Andre'
            }
        },
        data() {
            return {
                isClosed: true,
            }
        },
        methods: {
            toggleMenu() {
                this.isClosed = !this.isClosed
            },
        },
        filters: {
            firstletter(str) {
                if (str)
                    return str.split('').shift().toUpperCase()
            }
        },
        created() {
        }
    }
</script>
<style>
  .collapsed {
    transition: opacity 1s;
  }
</style>
